import * as actionTypes from './actionTypes';
import axios from 'axios';
import axiosDurex from '../../axios-setup';
//import * as fire from '../../config/firebase';
//import questions from '../questions';

//const apiKey = fire.default.options.apiKey;

export const quizInitAction = (token,uid) => {
	return dispatch => {
		//console.log(questions);
		dispatch(quizStartLoading());

		axiosDurex.get('/questions.json?auth='+token)
		.then(response => {
			//console.log('questions from base: '+ JSON.stringify(response.data));
			//console.log(questionsData);
			const getSessionDate = new Date().getTime();
			dispatch(quizStopLoading());
			dispatch(quizSetQuestions(response.data));
			dispatch(quizInit(getSessionDate));
		})
		.catch( err => {
			dispatch(quizStopLoading());
			//console.log(err);
			//dispatch(quizSetError(err.response.data.error));
			//dispatch(quizSetError("Pitanja nisu dostupna!"));
		});
	}
}

export const quizInit = (qs) => {
	return {
		type: actionTypes.QUIZ_INIT,
		quizSession: qs
	}
}

export const quizPushAction = (qSess,uid,actionType,actionVal) => {
	//console.log("quiz push action");
	const clDate = new Date().getTime();
	const qAction = actionType;
	const quizVal = actionVal!==undefined ? actionVal : true;
	const url = 'https://us-central1-durex-quiz-11996.cloudfunctions.net/addQuizAction?clDate='+clDate+'&quizSession='+qSess+'&quizAction='+qAction+'&quizActionValue='+quizVal+'&uid='+uid;
	return dispatch => {
		dispatch(quizStartLoading());
		axios.get(url)
		.then((response) => {
			//console.log('upisivanje u bazu res: ',response);
			//console.log('ovde treba promeniti na start');
			//console.log('qaction:',qAction);
			if (qAction==='start') {
				dispatch(quizChangeStage('started'));
			} else if (qAction==='answer') {
				dispatch(quizAnswer(quizVal));
			} else if (qAction==='end') {
				dispatch(quizAnswer(quizVal));
				dispatch(returnQuizSessionTotalTime(response.data.finalScore));
				dispatch(quizChangeStage('ended'));
			}
			dispatch(quizStopLoading());
		})
		.catch((err)=> {
			console.log('upisivanje u bazu err:',err);
		})
	}
}


export const returnQuizSessionTotalTime = (finalTime) => {
	return {
		type: actionTypes.QUIZ_ENDQUIZ,
		final: finalTime
	}
}

export const quizConfirmScore = (qSess,uid) => {
	//console.warn('QUIZ confirming total valid score');
	const url = 'https://us-central1-durex-quiz-11996.cloudfunctions.net/confirmQuizScore?quizSession='+qSess+'&uid='+uid;
	return dispatch => {
		dispatch(quizStartLoading());
		axios.get(url)
		.then((response) => {
			if (response.data === 'SCORE_CONFIRMED') {
				dispatch(quizChangeStage('finished'));
			}
		})
		.catch((err)=> {
			console.log('greska pri uzimanju vremena sesije:',err);
		});
	}
}

export const quizStartLoading = () => {
	return {
		type: actionTypes.QUIZ_STARTLOADING
	}
}

export const quizStopLoading = () => {
	return {
		type: actionTypes.QUIZ_STOPLOADING
	}
}

export const quizSetQuestions = (questions) => {
	return {
		type: actionTypes.QUIZ_SETQUESTIONS,
		q: questions
	}
}

export const quizChangeStage = (quizStage) => {
	return {
		type: actionTypes.QUIZ_CHANGESTAGE,
		stage: quizStage
	}
}

export const quizAnswer = (value) => {
	return {
		type: actionTypes.QUIZ_ANSWER,
		answer: value
	}
}


export const quizReset = () => {
	return {
		type: actionTypes.QUIZ_RESET,
	}
}


// WEBPACK FOOTER //
// ./src/store/actions/quiz.js